<template>
  <div>
    <PageTitle
      featureName="tasks"
      functionName="List"
      :pageName="$options.name"
    />

    <v-container fluid>
      <v-card class="mx-2 mt-3">
        <v-card-title><div class="subtitle-2">Open Tasks</div></v-card-title>
        <v-card-text>
          <TaskListItemCard
            v-for="st in taskList"
            :key="st.ScheduledTaskId"
            :st="st"
            @edit="taskListItemEditEvent"
          />
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog
      v-model="showScheduledTaskEditorDialog"
      :width="feature.tasks.dialogWidth"
      persistent
    >
      <ScheduledTaskEditor
        :isDialogOpen="showScheduledTaskEditorDialog"
        :scheduledTaskId="selectedScheduledTaskId"
        @update="scheduledTaskEditorUpdateEvent"
        @close="scheduledTaskEditorCloseEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { userData } from '@/store/UserSession'
import ScheduledTaskEditor from '@/components/ScheduledTask/ScheduledTaskEditor'
import TaskListItemCard from '@/components/ScheduledTask/TaskListItemCard'

export default {
  name: 'TasksPage',
  components: { ScheduledTaskEditor, TaskListItemCard },
  setup() {
    const taskList = ref([])
    const showScheduledTaskEditorDialog = ref(false)
    const selectedScheduledTaskId = ref()

    const initForm = async () => {
      refreshSearch()
    }

    const refreshSearch = async () => {
      const rq = { Criteria: userData.value.UserId }
      const rs = await host.scheduledTask.list(rq)
      taskList.value = rs.InfoList
    }

    const taskListItemEditEvent = scheduledTaskId => {
      selectedScheduledTaskId.value = scheduledTaskId
      showScheduledTaskEditorDialog.value = true
    }

    const scheduledTaskEditorCloseEvent = () => {
      showScheduledTaskEditorDialog.value = false
    }

    const scheduledTaskEditorUpdateEvent = () => {
      showScheduledTaskEditorDialog.value = false
      refreshSearch()
    }

    initForm()

    return {
      taskList,
      refreshSearch,
      taskListItemEditEvent,
      selectedScheduledTaskId,
      showScheduledTaskEditorDialog,
      scheduledTaskEditorCloseEvent,
      scheduledTaskEditorUpdateEvent,
      feature,
      icon
    }
  }
}
</script>

<style lang="scss" scoped></style>
